import './theme.css';

import { bootstrap } from '@/platform/app/bootstrap';

import { tenkoApp } from './app.definition';

bootstrap(tenkoApp, document.getElementById('root')!);
